// Third-party Imports
import { configureStore, createSlice } from '@reduxjs/toolkit'

// Slice Imports
// import chatReducer from '@/redux-store/slices/chat'
// import calendarReducer from '@/redux-store/slices/calendar'
// import kanbanReducer from '@/redux-store/slices/kanban'
// import emailReducer from '@/redux-store/slices/email'

// Placeholder slice to prevent empty reducer error
const placeholderSlice = createSlice({
  name: 'placeholder',
  initialState: {},
  reducers: {}
})

export const store = configureStore({
  reducer: {
    placeholder: placeholderSlice.reducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
